import React, { useEffect, useRef } from "react";
import styles from "./card-button.module.scss";
import Button from "../../../../../ui-kit/button/button";

interface Props {
  onClick: any;
  count: number;
  className?: string;
  buttonName: string;
}

function CardButton({ onClick, count, className, buttonName }: Props) {
  const buttonRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      event.stopPropagation(); // Останавливаем всплытие события
      onClick(); // Вызываем переданную функцию onClick
    };

    const buttonElement = buttonRef.current;

    if (buttonElement) {
      buttonElement.addEventListener("click", handleClick);

      // Убираем обработчик при размонтировании компонента
      return () => {
        buttonElement.removeEventListener("click", handleClick);
      };
    }
  }, [onClick]);

  return (
    <Button type="withIcon"
      className={`${className} ${styles.button}`}
      onClick={() => onClick()}
      ref={buttonRef}
    >
      <span>
        {count} {buttonName}
      </span>
    </Button>
  );
}

export default CardButton;
